import * as React from 'react';
import '../css/channel-icon.sass';

interface ChannelIconProps {
  iconUrl: string;
  name: string;
  displayLabel?: boolean;
  theme?: 'night' | 'day';
}

export default function ChannelIcon(props: ChannelIconProps) {
  const { theme = 'day', displayLabel = true } = props;
  return (
    <div className={`channel-icon ${theme}`}>
      <img alt={`${props.name}`} src={props.iconUrl} />
      {displayLabel && (
        <>
          <div className="divider" />
          <div className="ch-label">{props.name}</div>
        </>
      )}
    </div>
  );
}
